
  class SocialShare extends HTMLElement {
    constructor() {
        super();
        this.init();
    }
    init() {
        this.querySelectorAll('.btn-sharing').forEach(share => {
            share.addEventListener("click", event => {
              event.preventDefault();
              const target = event.currentTarget;
              const social = target.getAttribute('data-social');
              window.open(social);
            }, false);
        });
    }
  }
  customElements.define("social-share", SocialShare);

  (function autoLinkArticleKeywords() {
    const KEYWORD_LINKS = {
      "athletic shorts": "https://www.northyard.com/collections/northyard-men-shorts",
      "men's workout shorts": "https://www.northyard.com/collections/northyard-men-shorts",
      "5 inch inseam shorts": "https://www.northyard.com/collections/7-inch-inseam-shorts",
      "7 inch inseam shorts": "https://www.northyard.com/collections/7-inch-inseam-shorts",
      "9 inch inseam shorts": "https://www.northyard.com/collections/9-10-inch-inseam-shorts",
      "men's athletic wear": "https://www.northyard.com/",
      "men's sportswear": "https://www.northyard.com/"
    };

    const SKIP_TAGS = {
      A: true,
      SCRIPT: true,
      STYLE: true,
      NOSCRIPT: true,
      TEXTAREA: true,
      CODE: true,
      PRE: true,
      KBD: true,
      BUTTON: true,
      INPUT: true
    };

    function escapeRegExp(value) {
      return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    function keywordToPattern(keyword) {
      return escapeRegExp(keyword)
        .replace(/'/g, "['\\u2019]")
        .replace(/\s+/g, '\\s+');
    }

    function isSkippedTextNode(node) {
      var el = node.parentElement;
      while (el) {
        if (SKIP_TAGS[el.tagName]) return true;
        el = el.parentElement;
      }
      return false;
    }

    function normalizeKeyword(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\u2019/g, "'")
        .replace(/\s+/g, ' ')
        .trim();
    }

    function buildMatcher(entries) {
      var source = entries
        .map(function (entry) {
          return keywordToPattern(entry[0]);
        })
        .join('|');
      return new RegExp('\\b(?:' + source + ')\\b', 'gi');
    }

    function lookupUrl(matched, entries) {
      var normalized = normalizeKeyword(matched);
      for (var i = 0; i < entries.length; i++) {
        if (normalizeKeyword(entries[i][0]) === normalized) return entries[i][1];
      }
      return '';
    }

    function linkifyRoot(root) {
      var entries = Object.keys(KEYWORD_LINKS)
        .map(function (keyword) {
          return [keyword, KEYWORD_LINKS[keyword]];
        })
        .filter(function (entry) {
          return entry[0] && entry[1];
        })
        .sort(function (a, b) {
          return b[0].length - a[0].length;
        });

      if (!entries.length) return;

      var regex = buildMatcher(entries);
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (node) {
          if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          if (isSkippedTextNode(node)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      var textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);

      textNodes.forEach(function (textNode) {
        var text = textNode.nodeValue;
        regex.lastIndex = 0;
        if (!regex.test(text)) return;
        regex.lastIndex = 0;

        var fragment = document.createDocumentFragment();
        var lastIndex = 0;
        var match;

        while ((match = regex.exec(text)) !== null) {
          if (match.index > lastIndex) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
          }

          var url = lookupUrl(match[0], entries);
          if (url) {
            var link = document.createElement('a');
            link.href = url;
            link.className = 'article-auto-link';
            link.textContent = match[0];
            fragment.appendChild(link);
          } else {
            fragment.appendChild(document.createTextNode(match[0]));
          }

          lastIndex = match.index + match[0].length;
        }

        if (lastIndex < text.length) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        textNode.parentNode.replaceChild(fragment, textNode);
      });
    }

    function init() {
      var root = document.querySelector('#singleBlogPost .article-template__content');
      if (root) linkifyRoot(root);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  